// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/storage/v1/experiment_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchDeleteExperimentRequest, BatchDeleteExperimentResponse, BatchRecoverDeletedExperimentRequest, BatchRecoverDeletedExperimentResponse, CountExperimentsRequest, CountExperimentsResponse, CreateExperimentCommentRequest, CreateExperimentCommentResponse, CreateExperimentMetricRequest, CreateExperimentMetricResponse, CreateExperimentRequest, CreateExperimentResponse, DeleteExperimentRequest, GetExperimentRequest, GetExperimentResponse, IsExperimentRegisteredRequest, IsExperimentRegisteredResponse, LinkExperimentIntoProjectRequest, ListExperimentCommentsRequest, ListExperimentCommentsResponse, ListExperimentMetricsRequest, ListExperimentMetricsResponse, ListExperimentsRequest, ListExperimentsResponse, RecoverDeletedExperimentRequest, RecoverDeletedExperimentResponse, TagExperimentRequest, UnlinkExperimentFromProjectRequest, UntagExperimentRequest, UpdateExperimentRequest, UpdateExperimentResponse } from "@buf/h2oai_mlops-storage.bufbuild_es/ai/h2o/mlops/storage/v1/experiment_service_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service ai.h2o.storage.ExperimentService
 */
export const ExperimentService = {
  typeName: "ai.h2o.storage.ExperimentService",
  methods: {
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.GetExperiment
     */
    getExperiment: {
      name: "GetExperiment",
      I: GetExperimentRequest,
      O: GetExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.CreateExperiment
     */
    createExperiment: {
      name: "CreateExperiment",
      I: CreateExperimentRequest,
      O: CreateExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.UpdateExperiment
     */
    updateExperiment: {
      name: "UpdateExperiment",
      I: UpdateExperimentRequest,
      O: UpdateExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.DeleteExperiment
     */
    deleteExperiment: {
      name: "DeleteExperiment",
      I: DeleteExperimentRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.ListExperiments
     */
    listExperiments: {
      name: "ListExperiments",
      I: ListExperimentsRequest,
      O: ListExperimentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.CountExperiments
     */
    countExperiments: {
      name: "CountExperiments",
      I: CountExperimentsRequest,
      O: CountExperimentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.LinkExperimentIntoProject
     */
    linkExperimentIntoProject: {
      name: "LinkExperimentIntoProject",
      I: LinkExperimentIntoProjectRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.UnlinkExperimentFromProject
     */
    unlinkExperimentFromProject: {
      name: "UnlinkExperimentFromProject",
      I: UnlinkExperimentFromProjectRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.TagExperiment
     */
    tagExperiment: {
      name: "TagExperiment",
      I: TagExperimentRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.UntagExperiment
     */
    untagExperiment: {
      name: "UntagExperiment",
      I: UntagExperimentRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.CreateExperimentComment
     */
    createExperimentComment: {
      name: "CreateExperimentComment",
      I: CreateExperimentCommentRequest,
      O: CreateExperimentCommentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.ListExperimentComments
     */
    listExperimentComments: {
      name: "ListExperimentComments",
      I: ListExperimentCommentsRequest,
      O: ListExperimentCommentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.CreateExperimentMetric
     */
    createExperimentMetric: {
      name: "CreateExperimentMetric",
      I: CreateExperimentMetricRequest,
      O: CreateExperimentMetricResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.ListExperimentMetrics
     */
    listExperimentMetrics: {
      name: "ListExperimentMetrics",
      I: ListExperimentMetricsRequest,
      O: ListExperimentMetricsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.IsExperimentRegistered
     */
    isExperimentRegistered: {
      name: "IsExperimentRegistered",
      I: IsExperimentRegisteredRequest,
      O: IsExperimentRegisteredResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.BatchDeleteExperiment
     */
    batchDeleteExperiment: {
      name: "BatchDeleteExperiment",
      I: BatchDeleteExperimentRequest,
      O: BatchDeleteExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.RecoverDeletedExperiment
     */
    recoverDeletedExperiment: {
      name: "RecoverDeletedExperiment",
      I: RecoverDeletedExperimentRequest,
      O: RecoverDeletedExperimentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.ExperimentService.BatchRecoverDeletedExperiment
     */
    batchRecoverDeletedExperiment: {
      name: "BatchRecoverDeletedExperiment",
      I: BatchRecoverDeletedExperimentRequest,
      O: BatchRecoverDeletedExperimentResponse,
      kind: MethodKind.Unary,
    },
  }
};

